<template lang="html">
  <div class="col-xs center-xs pl-subheading">
    <chart
      :height="250"
      :type="'bubble'"
      :data="student_summary_bubble_chart"
      :options="optionsHeatMapBubble"
    >
    </chart>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Chart from 'components/chartJS/chartJS';
  import optionsHeatMapBubble from 'mixins/onlineBubbleOptions';

  const lightRed = 'rgba(255, 99, 132, 0.2)';
  const red = 'rgba(255, 99, 132, 1)';
  const lightBlue = 'rgba(54, 162, 235, 0.2)';
  const blue = 'rgba(54, 162, 235, 1)';

  export default {
    data() {
      return {};
    },
    components: {
      Chart,
    },
    computed: {
      ...mapGetters(['getStudentSummary']),
      peerRewards() {
        return this.getStudentSummary.points_settings.peer_rewards;
      },
      student_summary_bubble_chart() {
        if (this.getStudentSummary.diversity_info) {
          const diversityInfo = this.getStudentSummary.diversity_info;

          let maxX = Math.max(
            diversityInfo.average_comments_made,
            diversityInfo.comments_made
          );
          let maxY = Math.max(
            diversityInfo.average_comment_stars_per_student,
            diversityInfo.total_comment_stars
          );

          maxX = maxX % 10 === 0 ? maxX + 10 : Math.ceil(maxX / 10) * 10;
          maxY = maxY % 10 === 0 ? maxY + 10 : Math.ceil(maxY / 10) * 10;
          this.optionsHeatMapBubble.scales.xAxes[0].ticks.max = maxX;
          this.optionsHeatMapBubble.scales.yAxes[0].ticks.max = maxY;

          const avgComments = diversityInfo.average_comments_made;
          const avgStars = diversityInfo.average_comment_stars_per_student;
          const comments = diversityInfo.comments_made;
          const commentStars = diversityInfo.total_comment_stars;

          return {
            datasets: [
              {
                backgroundColor: lightRed,
                borderColor: red,
                hoverBackgroundColor: red,
                label: 'Class Average',
                user_id: null,
                data: [
                  {
                    x: avgComments,
                    y: avgStars,
                    r: 13,
                  },
                ],
              },
              {
                backgroundColor: lightBlue,
                borderColor: blue,
                hoverBackgroundColor: blue,
                label: this.getStudentSummary.user.name || 'student',
                user_id: null,
                data: [
                  {
                    x: comments,
                    y: commentStars,
                    r: 13,
                  },
                ],
              },
            ],
          };
        }
        return null;
      },
    },
    mixins: [optionsHeatMapBubble],
    methods: {},
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// studentCommentSummaryGraph.vue?62e892a8